"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertUnits = void 0;
const getUnitConversion_1 = require("./getUnitConversion");
const simplifyAmount_1 = require("./simplifyAmount");
const common_1 = require("@saffron/common");
const unitToConvertTo = {
    cup: "milliliter",
    "fluid ounce": "milliliter",
    gallon: "liter",
    ounce: "gram",
    pound: "gram",
    gram: "pound",
    kilogram: "pound",
    liter: "cup",
    milliliter: "cup",
    milligram: "pound",
};
const sixtenthCupRegex = /^(\d\d?)\/16$/;
exports.convertUnits = (ingredients, systemToConvertTo) => ingredients.map(ogIg => {
    if (ogIg.__typename === "RegularIngredient" && ogIg.amount && ogIg.name) {
        let ig = Object.assign({}, ogIg);
        if (!ogIg.unit) {
            const simplifyInfo = simplifyAmount_1.simplifyAmount(ogIg.amount, ogIg.name);
            if (simplifyInfo) {
                ig.amount = simplifyInfo.amount;
                ig.unit = simplifyInfo.unit;
                ig.name = simplifyInfo.name;
            }
        }
        const { first, second } = getUnitConversion_1.getUnitConversion(ig);
        const firstUnitType = (first === null || first === void 0 ? void 0 : first.unit) ? common_1.getUnitType(first.unit) : null;
        if (systemToConvertTo === firstUnitType) {
            return first;
        }
        const secondUnitType = (second === null || second === void 0 ? void 0 : second.unit) ? common_1.getUnitType(second.unit) : null;
        if (systemToConvertTo === secondUnitType) {
            return second;
        }
        if (firstUnitType === "unknown" && secondUnitType !== "unknown") {
            return first;
        }
        if (firstUnitType !== "unknown" && secondUnitType === "unknown") {
            return second;
        }
        const unitType = common_1.getUnitType(ig.unit);
        const currentUnit = common_1.normalizeUnitMap[ig.unit];
        if (unitType === "unknown" ||
            unitType === systemToConvertTo ||
            !(currentUnit in unitToConvertTo)) {
            return ig;
        }
        const newUnit = unitToConvertTo[currentUnit];
        let conversion = common_1.convertStringAmountEstimate({
            amount: ig.amount,
            currentUnit,
            toUnit: newUnit,
        });
        if (newUnit === "gram") {
            const intAmount = parseFloat(conversion.amount);
            if (intAmount >= 1000) {
                conversion = common_1.convertStringAmountEstimate({
                    amount: ig.amount,
                    currentUnit,
                    toUnit: "kilogram",
                });
            }
        }
        if (newUnit === "pound") {
            const intAmount = parseFloat(conversion.amount);
            if (intAmount < 1) {
                conversion = common_1.convertStringAmountEstimate({
                    amount: ig.amount,
                    currentUnit,
                    toUnit: "ounce",
                });
            }
        }
        if (newUnit === "cup") {
            const m = conversion.amount.match(sixtenthCupRegex);
            if (m) {
                conversion.amount = m[1];
                if (conversion.amount === "1") {
                    conversion.unit = "tablespoon";
                }
                else {
                    conversion.unit = "tablespoons";
                }
            }
            const intAmount = parseFloat(conversion.amount);
            if (intAmount < 1) {
                conversion = common_1.convertStringAmountEstimate({
                    amount: ig.amount,
                    currentUnit,
                    toUnit: "teaspoon",
                });
            }
        }
        return Object.assign(Object.assign({}, ig), conversion);
    }
    return ogIg;
});
//# sourceMappingURL=convertUnits.js.map